import {useInfiniteQuery, useQuery} from "@tanstack/react-query";
import * as api from "../../../api";


export const useRegionsInfiniteQuery = (filter, enabled=true) => {
    return useInfiniteQuery({
        queryKey: ['regions', filter],
        queryFn: async ({pageParam=0}) => {
            const data = await api.Territory.getRegions({...filter, page_index: pageParam, page_size: 50});
            return {
                items: data.rows,
                nextPage: data.rows.length === 50 ? pageParam + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage) => lastPage.nextPage,
        enabled: enabled,
    });
}

export const useRegionQuery = (regionId, options) => {
    return useQuery({
        queryKey: ['region', regionId],
        queryFn: async () => {
            const data = await api.Territory.getRegion(regionId);
            return data;
        },
        enabled: regionId !== null && regionId !== undefined,
        ...options
    });
}